import {useContaCommand} from '@/commandbar/commandBar.service'
import {isDark, setDark, setLight} from '@/theme/theme.service'

const {registerCommand} = useContaCommand()

registerCommand({
    type: 'theme',
    typeLabel: 'Fargemodus',
    label: 'Lys',
    key: 'light',
    icon: 'i-ph-sun',
    activate: setLight,
    isActive: () => !isDark.value
})
registerCommand({
    type: 'theme',
    typeLabel: 'Fargemodus',
    label: 'Mørk',
    key: 'dark',
    icon: 'i-ph-moon',
    activate: setDark,
    isActive: () => isDark.value
})